import React from 'react';
import '../Tutorial.css';
import Typewriter from "typewriter-effect";
import TutorialGirl from "../TutorialGirl";

function T150Final() {

    const text = 'You’ve grown stronger than I expected. From here on, you won’t walk alone — meet your new companion, Slymera Evergrowth.\n' +
        '\n' +
        'Your next path leads to the Tower of Lust. Cultists of a dark god have seized it and extinguished the sacred crystal that once blessed these lands.\n' +
        '\n' +
        'Climb the tower. Purge them. Perform the cleansing ritual… and reignite the crystal.\n' +
        '\n' +
        'Your true journey begins now.';

    return <div>

        <div className={'T150Left'}></div>
        <div className={'T150Right'}></div>
        <div className={'T150Bottom'}></div>

        <TutorialGirl undressingProcess={3}/>
        <div className='tutorialContainer tutorialTopContainer95'>
            <div className='tutorialBottomTextField'><Typewriter
                options={{
                    delay: 30
                }}
                onInit={(typewriter) => {
                    typewriter.typeString(text).start();
                }}
            /></div>
        </div>
        <div className={"T150SlimeGirl map-cpu-ico-Lust-Tower"}></div>
    </div>
}

export default T150Final;